import type { SubcontractorComplianceState } from "../types/types.ts"

export const COMPLIANCE_STATUS_COLOR_MAP: Record<
  SubcontractorComplianceState,
  string
> = {
  valid: "green",
  expiring_soon: "gold",
  expired: "red",
  no_expiry: "default"
}

export const COMPLIANCE_DOCUMENT_LABELS: Record<string, string> = {
  workers_comp: "Workers' Comp",
  general_liability: "General Liability",
  license: "License",
  w9: "W-9",
  miscellaneous: "Miscellaneous"
}

// Fixed reading order; the API returns only what the subcontractor supplied.
export const COMPLIANCE_DOCUMENT_ORDER = Object.keys(COMPLIANCE_DOCUMENT_LABELS)

// Mirrors the server's own check (`documents.validate_document_file`).
export const COMPLIANCE_DOCUMENT_EXTENSIONS = ["pdf", "png", "jpg", "jpeg"]
export const COMPLIANCE_DOCUMENT_MAX_MB = 10
